<template>
  <div
    v-if="isVisible"
    class="modal show d-block fade"
    tabindex="-1"
    style="background: rgba(0,0,0,0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content modal-thin-header">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="requestClose"></button>
        </div>

        <div class="modal-body bg-white">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmDiscard } from '@/components/utils/ConfirmDialogue.vue'

export default {
  name: 'FormModal',

  props: {
    title: {
      type: String,
      default: 'Fill In Form',
    },
    size: {
      type: String,
      default: 'modal-md',
    },
  },

  emits: ['close'],

  data() {
    return {
      isVisible: false,
      isDirty: false,
    }
  },

  // Expose these to any component in the <slot>, however deeply nested,
  // with no $refs or prop bridging needed.
  provide() {
    return {
      formGuard: {
        markDirty: () => this.markDirty(),
        markClean: () => this.markClean(),
        requestClose: () => this.requestClose(),
      },
    }
  },

  methods: {
    showModal() {
      this.isVisible = true
      this.isDirty = false
    },

    markDirty() {
      this.isDirty = true
    },

    markClean() {
      this.isDirty = false
    },
    async requestClose() {
      const canClose = await confirmDiscard(this.isDirty, {
        message: 'You have unsaved changes. If you close this, they will be discarded.',
      })
      if (!canClose) return

      this.isDirty = false
      this.isVisible = false
      this.$emit('close')
    },
    closeModal() {
      return this.requestClose()
    },
  },
}
</script>
